export default "__VITE_PUBLIC_ASSET__b237cd5d__"